export default __webpack_public_path__ + "static/media/irrigation_timing_adhoc.ebd5a4ae.jpg";